<p-panel header="Image Gallery" styleClass="panel-shadow">
  <div class="gallery-wrapper mt-2">
    <job-screen-gallery
      [images]="pickupImages"
      type="1"
      [showAddButton]="canAddPhoto(1)"
      [disableAddButton]="organisationTypeId != 1 && commonService.isJobCancelled(jobInfo)"
      (onAddPhoto)="showAddPhotoToTaskStep($event)"
      (onDeletePhoto)="deletePhotoToTaskStep($event, 1)"
      (onEditPhoto)="showEditPhotoToTaskStep($event, 1)"
      (onShowOdometerPhoto)="showOdometerPhoto($event)"
      (onSetAreaCondition)="showSetAreaCondition($event)"
    ></job-screen-gallery>
  </div>

  <div class="gallery-wrapper mt-2">
    <job-screen-gallery
      [images]="dropoffImages"
      type="3"
      [showAddButton]="canAddPhoto(3)"
      [disableAddButton]="organisationTypeId != 1 && commonService.isJobCancelled(jobInfo)"
      (onAddPhoto)="showAddPhotoToTaskStep($event)"
      (onDeletePhoto)="deletePhotoToTaskStep($event, 3)"
      (onEditPhoto)="showEditPhotoToTaskStep($event, 3)"
      (onSetAreaCondition)="showSetAreaCondition($event)"
    ></job-screen-gallery>
  </div>
</p-panel>

<p-dialog
  [header]="isShowAddPhotoToTaskStep ? 'Add Photo to Step' : 'Update Photo Data'"
  [(visible)]="isAddEditPhotoDialogVisible"
  [responsive]="true"
  [modal]="true"
  (onHide)="closeAddPhotoToTaskStep()"
  [style]="{ width: '450px' }"
>
  <div class="style2023 pb-2">
    <div *ngIf="!selectedCompleteTaskStep" style="font-size: 0.9em; text-align: center" class="p-3">
      Before you can upload a photo this step must be marked as completed in driver checklist.
    </div>

    <div class="input-group mt-3">
      <div class="input-group-prepend">Area</div>
      <div class="input-group-item">
        <p-dropdown
          [options]="areas"
          placeholder="Select area"
          [disabled]="!selectedCompleteTaskStep"
          [style]="{ width: '100%' }"
          [(ngModel)]="selectedArea"
          filter="filter"
          (onChange)="onAreaChange()"
        ></p-dropdown>
      </div>
    </div>

    <div class="input-group mt-3">
      <div class="input-group-item pt-2">
        <textarea
          maxlength="250"
          style="width: 100%"
          placeholder="Enter Photo Description.."
          class="no-border"
          pInputTextarea
          [(ngModel)]="addPhotoDescription"
        ></textarea>
      </div>
    </div>

    <div class="input-group mt-3">
      <div class="input-group-prepend">Condition</div>
      <div class="input-group-item">
        <p-dropdown
          [options]="conditions"
          placeholder="Select condition"
          (onChange)="onConditionChange()"
          [disabled]="!selectedCompleteTaskStep"
          [style]="{ width: '100%' }"
          [(ngModel)]="selectedCondition"
          filter="filter"
        ></p-dropdown>
      </div>
    </div>

    <div *ngIf="selectedCondition != 0 && selectedCondition != 4" class="input-group mt-3">
      <div class="input-group-item pt-2">
        <textarea
          pInputTextarea
          placeholder="Enter Condition Comment.."
          rows="3"
          class="no-border"
          [(ngModel)]="conditionComment"
          style="width: 100%"
          maxlength="250"
        ></textarea>
      </div>
    </div>
    <div *ngIf="isShowAddPhotoToTaskStep" class="ui-g-12">
      <div class="text-right">
        <div style="margin-left: -5px">
          <p-fileUpload
            name="files"
            multiple="true"
            url="/api/filestorage/multiplefileuploading"
            (onProgress)="progressUploading($event)"
            (onBeforeUpload)="onBeforeUpload($event)"
            (onSelect)="onSelect($event)"
            (onError)="onError($event)"
            (onUpload)="onMultipleFileUpload($event)"
            withCredentials="true"
            [maxFileSize]="83886080"
            accept="application/pdf,image/*,.heic"
            auto="true"
            chooseLabel="Upload Photo"
            mode="basic"
          ></p-fileUpload>
        </div>
        <li *ngFor="let uploadResult of multipleFileUploadResult" class="list-group-item">
          <div class="uploaded-photo" [ngSwitch]="uploadResult.fileData.extension">
            <i *ngSwitchCase="'pdf'" class="fa fa-file-pdf-o pdf-icon" aria-hidden="true"></i>
            <img
              *ngSwitchDefault
              [src]="uploadResult.presignedUrl"
              class="ui-galleria-frame-image"
              width="60"
              alt=""
              height="40"
            />
            <div class="filename">{{ uploadResult?.fileData?.name }}</div>
            <div *ngIf="uploadResult?.errorMessage">{{ uploadResult.errorMessage }}</div>
          </div>
        </li>
      </div>
    </div>
  </div>

  <p-footer>
    <button
      type="button"
      (click)="closeAddPhotoToTaskStep()"
      pButton
      icon="fa ui-icon-close"
      label="Cancel"
      class="ui-button ui-button-tertiary"
    ></button>

    <button
      type="button"
      pButton
      icon="fa ui-icon-check"
      [label]="isShowAddPhotoToTaskStep ? 'Save Photo' : 'Update Photo'"
      class="ui-button ui-button-primary"
      (click)="saveMultiplePhotosOnStep()"
      [disabled]="
        !selectedCompleteTaskStep ||
        (!selectedImage && multipleFileUploadResult?.length <= 0) ||
        !selectedCompleteTaskStep ||
        (!selectedArea && !selectedArea == null) ||
        selectedCondition == null ||
        !isConditionCommentValid()
      "
    ></button>
  </p-footer>

  <div
    style="
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: gray;
      opacity: 0.3;
    "
    *ngIf="isBusyAddPhotoToStep || isBusyUploadImage"
  >
    <img
      src="assets/images/loader.gif"
      style="margin-left: 45%; margin-top: 10%"
      width="50"
      height="50"
      alt="load"
    />
  </div>
</p-dialog>

<p-dialog
  header="Set Area Condition"
  [(visible)]="isShowSetAreaCondition"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '450px' }"
>
  <div class="style2023 mt-2 pb-2">
    <div
      class=""
      *ngIf="!selectedCompleteTaskStep"
      style="font-size: 0.9em; font-style: italic; text-align: center"
    >
      Before you can set condition this step must be marked as completed in driver checklist.
    </div>

    <div class="input-group">
      <div class="input-group-prepend" style="width: 100px">Area</div>
      <div class="input-group-item">
        <p-dropdown
          [options]="areas"
          placeholder="Select area"
          [disabled]="!selectedCompleteTaskStep"
          [style]="{ width: '100%' }"
          (onChange)="onAreaChange()"
          [(ngModel)]="selectedArea"
          filter="filter"
        ></p-dropdown>
      </div>
    </div>

    <div class="input-group mt-3">
      <div class="input-group-prepend" style="width: 100px">Condition</div>
      <div class="input-group-item">
        <p-dropdown
          [options]="conditions"
          placeholder="Select condition"
          (onChange)="onConditionChange()"
          [disabled]="!selectedCompleteTaskStep"
          [style]="{ width: '100%' }"
          [(ngModel)]="selectedCondition"
          filter="filter"
        ></p-dropdown>
      </div>
    </div>

    <div *ngIf="selectedCondition != 0 && selectedCondition != 4">
      <div class="input-group mt-3">
        <div class="input-group-item pt-2">
          <textarea
            pInputTextarea
            placeholder="Enter Condition Comment.."
            rows="3"
            [(ngModel)]="conditionComment"
            style="width: 100%"
            class="no-border"
            maxlength="250"
          ></textarea>
        </div>
      </div>
    </div>
  </div>

  <p-footer>
    <div class="text-right">
      <button
        type="button"
        (click)="closeSetAreaCondition()"
        pButton
        label="Cancel"
        class="ui-button ui-button-tertiary"
      ></button>
      <button
        type="button"
        pButton
        label="Set Condition"
        class="ui-button ui-button-primary"
        (click)="setAreaCondition()"
        [disabled]="
          !selectedCompleteTaskStep ||
          (!selectedArea && !selectedArea == null) ||
          selectedCondition == null ||
          !isConditionCommentValid()
        "
      ></button>
    </div>
  </p-footer>
  <div
    style="
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: gray;
      opacity: 0.3;
    "
    *ngIf="isBusySetAreaCondition"
  >
    <img
      src="assets/images/loader.gif"
      style="margin-left: 45%; margin-top: 10%"
      width="50"
      height="50"
      alt="load"
    />
  </div>
</p-dialog>

<view-odometer-image-dialog
  *ngIf="odometerImageSource"
  [(visible)]="showOdometerImage"
  [imageSource]="odometerImageSource"
  (visibleChange)="odometerDialogVisibleChanged($event)"
>
</view-odometer-image-dialog>
